export default "__VITE_ASSET__B1mA5S7R__"